import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import DocumentTitle from 'react-document-title';

import { connect } from 'react-redux';
import { fetchContacts } from '../../store/actions/contacts';
import { selectPropertyManagers } from '../../store/selectors/contacts';
import { selectPropertyFormData } from '../../store/selectors/propertyForm';
import { setPropertyFormData,clearPropertyFormData } from '../../store/actions/propertyForm';
import Button from '../../components/Button';
import Col from '../../components/Col';
import Form, { Heading } from '../../components/Form';
import Input from '../../components/Input';
import File from '../../components/File';
import Row from '../../components/Row';

import Select from '../../components/Select';
import { PATHS, ErrorMessages } from '../../common/constants';
import { signIn } from '../../store/actions/auth';
import { selectAuthenticatedUser } from '../../store/selectors/auth';
import { throwStatement } from '@babel/types';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import FontAwesomeIcon from '../../components/Icon';

class ChangePasswordForm extends Component {
  constructor(props){
    super(props);
    this.state={
      old_password:'',
      password:'',
      confirm_password:'',
      validated:false,
      passwordError: '',
      confirmPasswordError: '',
      errors: {
        passwordCapitalError: true,
        passwordLowerError: true,
        passwordNumberError: true,
        passwordLengthError: true,
        passwordSpecialCharecterError: true
      }

    }
  }
  componentDidMount() {
    
  }

  validatePasswordForm(){
    const { old_password, password, confirm_password } = this.state;

    

    if(password === confirm_password){

      let data ={
        Username: this.props.user.email,
        Password: old_password
      }
      let newData = {
        "UserId": this.props.user.id,
        "Password": old_password,
        "NewPassword": confirm_password
    }
      let history = this.props.history
      this.props.signIn(data,history,newData)
        
    }else{
      toast.error('🚫 Your new password and confirm password must be the same.',{autoClose:12000,position:'top-center'})
    }
    

    
   
  }
  navigteToSettingsPage(){
    this.setState({
      old_password:'',
      password:'',
      confirm_password:''
    },()=>{
    
    this.props.history.push(PATHS.SETTINGS)
    })
    
  }

  onChangePasssword = (text, type) => {
    this.setState({ [type]: text })
    this.checkPasswordRequirements(text, type);
}
onFocus = (text, type) => {
  this.checkPasswordRequirements(text, type);
}
/*
  Modified By: Sai Prasad
  Modified Date: 06/10/2022
  Jira Ticket: JUN-3323
  Description: password requirements.
*/
checkPasswordRequirements = (text, type) => {
  const { errors } = this.state;
  let passwordCapital = /(?=.*[A-Z])/;
  let passwordLower = /(?=.*[a-z])/;
  let passwordNumber = /(?=.*\d)/;
  let passwordSpecialCharecter = /[!@#\$%\^\&*\)\(+=._-]/
  errors.passwordLengthError = (text.trim().length < 8 || text.trim().length > 20) ? true : false;
  errors.passwordCapitalError = passwordCapital.test(text.trim()) ? false : true;
  errors.passwordLowerError = passwordLower.test(text.trim()) ? false : true;
  errors.passwordNumberError = passwordNumber.test(text.trim()) ? false : true;
  errors.passwordCapitalError = passwordCapital.test(text.trim()) ? false : true;
  errors.passwordSpecialCharecterError = passwordSpecialCharecter.test(text.trim()) ? false : true;
  let validation = !errors.passwordLengthError && !errors.passwordCapitalError && !errors.passwordLowerError && !errors.passwordNumberError && 
  !errors.passwordCapitalError && !errors.passwordSpecialCharecterError
  
  this.setState({ errors})
    this.setState(type === 'password' ? {passwordError: validation} : {confirmPasswordError: validation})
}


  render() {
    const { old_password, password, confirm_password, errors } = this.state;
    const theme = localStorage.getItem('theme');

    return (
      <DocumentTitle title={ theme === 'Shape'?`${'Change Password'} | SHAPE`:`${'Change Password'} | juniper`}>
      <Form
        headline={'Change Password'}
        onClose={ () => this.navigteToSettingsPage()}
        onSubmit={() => this.validatePasswordForm()}
        actions={(
          <>
          <div/>
            <Button
              color="teal"
              size="small"
              label="Save Password"
              onClick={ ()=> this.setState({
                buttonPressed:'SaveAndClose'
              })}
              disabled={!old_password || !password || !confirm_password || !this.state.passwordError || !this.state.confirmPasswordError}
            
            />
          </>
        )}
        component={(
          <>
            <Row mdCenter>
              <Col
                xs="12"
                md="6"
              >
                <Heading></Heading>
                <>
                        <Input
                          label="Old Password"
                          placeholder="Old Password"
                          value={old_password}
                          onChange={e => this.setState({ old_password: e.target.value })}
                          block
                          mask
                        />
                        <Input
                          label="New Password"
                          placeholder="New Password"
                          value={password}
                          onChange={e => this.onChangePasssword(e.target.value, 'password')}
                          onfocus={() => this.onFocus(this.state.password, 'password')}
                          block
                          mask
                        />
                        <Input
                          label="Confirm Password"
                          placeholder="Confirm Password"
                          value={confirm_password}
                          onChange={e => this.onChangePasssword(e.target.value, 'confirm_password')}
                          onfocus={() => this.onFocus(this.state.confirm_password, 'confirm_password')}
                          block
                          mask
                        />
                      </>
              {!this.state.passwordError || !this.state.confirmPasswordError ?
                <div style={{marginBottom: 20}}>
                  <div style={{fontSize: 25, marginBottom: 10, textAlign: 'start'}}>Password Requirements:</div>
                  {/* <Icon glyph="check" weight="solid" size="small" /> */}
                   <div style={{color: errors.passwordLengthError ? 'red': 'green', fontSize: 14, marginBottom: 3, textAlign: 'start'}}>
                   <FontAwesomeIcon glyph={errors.passwordLengthError ? "times" : "check"} weight="solid" size="small" />
                     <label style={{paddingLeft: 10}}>{ErrorMessages.passwordRequirement1}</label>
                     </div>
                <div style={{color: errors.passwordCapitalError ? 'red': 'green',fontSize: 14, marginBottom: 3, textAlign: 'start'}}>
                <FontAwesomeIcon glyph={errors.passwordCapitalError ?  "times" : "check"} weight="solid" size="small" />
                <label style={{paddingLeft: 10}}>{ErrorMessages.passwordRequirement2}</label>
                  </div>
                <div style={{color: errors.passwordLowerError ? 'red': 'green', fontSize: 14, marginBottom: 3, textAlign: 'start'}}>
                <FontAwesomeIcon glyph={errors.passwordLowerError ?  "times" : "check"} weight="solid" size="small" />
                <label style={{paddingLeft: 10}}>{ErrorMessages.passwordRequirement3}</label>
                  </div>
                <div style={{color: errors.passwordNumberError ? 'red': 'green', fontSize: 14, marginBottom: 3, textAlign: 'start'}}>
                <FontAwesomeIcon glyph={errors.passwordNumberError ?  "times" : "check"} weight="solid" size="small" />
                <label style={{paddingLeft: 10}}>{ErrorMessages.passwordRequirement4}</label>
                  </div>
                <div style={{color: errors.passwordSpecialCharecterError ? 'red': 'green', fontSize: 14, marginBottom: 3, textAlign: 'start'}}>
                <FontAwesomeIcon glyph={errors.passwordSpecialCharecterError ?  "times" : "check"} weight="solid" size="small" />
                <label style={{paddingLeft: 10}}>{ErrorMessages.passwordRequirement5}</label>
                  </div>
                </div>: null }
                </Col>
            </Row>
          </>
        )}
      />
      </DocumentTitle>
    );
  }
}

const mapStateToProps = state => ({
 user:selectAuthenticatedUser(state)
});

const mapDispatchToProps = dispatch => bindActionCreators({
  signIn: signIn,
  
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ChangePasswordForm);